var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136,
    height: 64,
    fill: "none",
    viewBox: "0 0 136 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2E85EF",
    d: "M111.95 1H23.976l-2.928 1.22v3.308l2.524 1.965c.24.223.433.493.563.794.131.3.198.624.196.952l6.127 18.942c.098 1.758 1.054 3.15 2.193 3.15h70.82c1.14 0 2.095-1.392 2.181-3.15l6.126-18.93c.003-.324.071-.644.199-.942.128-.297.315-.566.549-.791l2.45-1.99V2.221L111.95 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F3251",
    d: "M106.583 5.882H23.361L21.379 8.21v3.709l2.53 2.498c.238.278.43.615.561.992.132.376.201.784.204 1.196l-2.65 17.07c.097 2.188 1.045 3.941 2.188 3.941h86.809c1.143 0 2.091-1.753 2.176-3.941l-1.872-17.07c0-.41.065-.816.193-1.192.127-.377.314-.716.549-.996l2.432-2.498v-3.71l-7.916-2.327z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#143C6D",
    d: "M110.823 36.396H23.83v7.323h86.993v-7.323z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#164E93",
    d: "M26.856 9.495l-6.274 9.899 5.024 18.515 1.69 2.392 2.048-3.905-2.488-26.901zM108.691 9.495l6.286 9.899-5.036 18.515-1.691 2.392-2.328-4.516 2.769-26.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E85EF",
    d: "M112.636 17.172s2.034 1.77 1.997 2.441l-5.44 16.868c-.073 1.562-.931 2.807-1.948 2.807H28.02c-1.017 0-1.875-1.22-1.96-2.807l-5.453-16.88c0-.671 1.924-2.441 1.924-2.441l-.098-2.356H3v9.069l3.516 2.758c.338.311.606.689.787 1.11.182.42.273.874.267 1.331l8.577 25.558c.123 2.442 1.458 4.394 3.039 4.394h97.763c1.593 0 2.904-1.94 3.039-4.394l8.503-25.558c-.002-.456.089-.907.268-1.327.18-.42.443-.799.774-1.114l3.455-2.77v-9.045h-20.131l-.221 2.356z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M111.95 1H23.976c-.122.073-2.928 1.22-2.928 1.22h93.891S112.048 1.146 111.95 1z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B1C30",
    d: "M33.51 6.43h69.006c.106-.08.221-.15.343-.207l1.948-.78H31.181l1.985.768c.133.04.252.115.343.22z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.086 24.02l3.48 2.746c.33.314.593.693.77 1.113.177.42.265.872.259 1.328l8.515 25.497c.123 2.44 1.446 4.284 3.027 4.284h5.746l-2.45-1.11c-2.732-1.38-4.632-5.237-4.767-9.68L12.46 17.184H3.086v6.835zM120.012 54.704l8.479-25.51c.006-.447.102-.888.283-1.297.181-.409.443-.777.771-1.083L133 24.068v-6.835h-9.312l-5.22 30.965c-.147 4.443-2.046 8.215-4.778 9.594l-2.451 1.147h5.71c1.617 0 2.928-1.794 3.063-4.235z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#589EF4",
    d: "M28.706 10.52H17.385l-14.3 4.296h19.36l6.261-4.296zM106.583 10.52h12.118l14.311 4.296h-20.155l-6.274-4.296z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B5FB2",
    d: "M28.706 10.52l-6.273 4.296.085 2.368 6.274-4.674-.086-1.99zM30.47 5.272l-1.764 1.245v3.613l.086 2.367 1.593-1.269.085-5.956zM104.807 5.272l1.776 1.245-.012 3.613-.086 2.367-1.58-1.269-.098-5.956zM106.583 10.52l6.274 4.296-.086 2.368-6.273-4.674.085-1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E85EF",
    d: "M118.701 6.517h-12.118v4.003h12.118V6.517zM28.706 6.517H17.397v4.003h11.31V6.517z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#589EF4",
    d: "M104.807 5.272h9.838l4.056 1.244h-12.118l-1.776-1.244zM30.47 5.272h-9.03l-4.055 1.244h11.321l1.765-1.244z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22.004 23.91H3l3.516 2.721c.277.18.49.44.613.745h15.99l-1.115-3.466zM113.273 23.91l-1.115 3.466h16.811c.167-.262.364-.504.588-.72l3.455-2.746h-19.739zM20.607 19.6c-.006-.024-.006-.05 0-.073.17-.576.523-1.08 1.005-1.44l.907-.867H3.086v4.04h18.06l-.539-1.66zM112.686 17.184l.906.867c.477.378.823.894.993 1.477-.006.024-.006.049 0 .073l-.539 1.66H133v-4.077h-20.314z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#589EF4",
    d: "M107.723 39.288H28.02v1.013h79.703v-1.013zM27.505 40.301c-.257-.415-.514-.854-.772-1.293-3.215-5.614-5.296-11.8-6.126-18.21v-1.221l5.428 16.892 1.47 3.832z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M110.124 44.414H25.606l2.414-4.113h79.691l2.413 4.113z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#589EF4",
    d: "M107.71 40.301c.27-.415.527-.854.785-1.293 3.21-5.616 5.291-11.802 6.126-18.21v-1.221l-5.428 16.904-1.483 3.82z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 67.865,
    x2: 67.865,
    y1: 44.414,
    y2: 40.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H130V58H0z",
    transform: "translate(3 1)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    width: 136,
    height: 64,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.533f800f6aefa11e507a46485e29d3cb.svg";
export { ForwardRef as ReactComponent };